import _ from 'lodash';
import AccountsStore from '../../../stores/AccountsStore';
import NumberUtils from '../../../utils/NumberUtils';
import StringConstants from '../../../constants/StringConstants';
import envConfig from '../../../../static/config';
import BrowserUtils from '../../../utils/BrowserUtils';
import ContentStore from '../../../stores/InternetBankingContentStore';
import UserManagementStore from '../../../stores/UserManagementStore';
import { isCardManagementEnabledForAccount } from '../../../utils/CardManagementUtils';
import { shouldShowDocumentLib } from '../../homepage/HomepageTilesUtils';

export const transactionCategories = {
  DEFAULT: 'default',
  PERACCOUNT: 'per-account',
};
class AccountDetailsBL {
  getAccountDisplayNumber(accountDetails) {
    if (accountDetails.type === 'credit_card') {
      let creditcardNumber = _.replace(
        accountDetails.number,
        '************',
        'xxxxxxxxxxxx'
      );
      creditcardNumber = _.split(creditcardNumber, '-');
      const creditcard = NumberUtils.formatCreditCard(creditcardNumber[0]);
      return ` ${creditcard}`;
    } else if (
      accountDetails.product.code === StringConstants.KAPITI_PRODUCT_CODE
    ) {
      const accountNumber = _.split(accountDetails.number, '-');
      return accountNumber[1];
    } else {
      const accountNumber = _.split(accountDetails.number, '-');
      const sortcode = NumberUtils.formatSortCode(accountNumber[0]);
      return `${sortcode} | ${accountNumber[1]}`;
    }
  }
  getBalances(accountDetails) {
    let currentBalance;
    let availableBalance;
    let clearedBalance;
    let closingBalancePreviousBusinessDay;
    let clearedBalancePreviousBusinessDay;
    let isaTaxYearDateDeposits;
    let isaTotalDepositAllowance;

    const balances = _.get(
      accountDetails,
      'accountDetails.balances',
      _.get(accountDetails, 'balances')
    );
    _.map(balances, ({ amount, currency, type }) => {
      switch (type) {
        case 'current':
          currentBalance = NumberUtils.appendCurrency('{}', amount, currency);
          break;
        case 'available':
          availableBalance = NumberUtils.appendCurrency('{}', amount, currency);
          break;
        case 'cleared':
          clearedBalance = NumberUtils.appendCurrency('{}', amount, currency);
          break;
        case 'previous_business_day':
          closingBalancePreviousBusinessDay = NumberUtils.appendCurrency(
            '{}',
            amount,
            currency
          );
          break;
        case 'cleared_previous_business_day':
          clearedBalancePreviousBusinessDay = NumberUtils.appendCurrency(
            '{}',
            amount,
            currency
          );
          break;
        case 'isa_taxyear_to_date_deposits':
          isaTaxYearDateDeposits = NumberUtils.appendCurrency(
            '{}',
            amount,
            currency
          );
          break;
        case 'isa_total_deposits_allowance_remaining':
          isaTotalDepositAllowance = NumberUtils.appendCurrency(
            '{}',
            amount,
            currency
          );
          break;
      }
    });
    return {
      currentBalance,
      availableBalance,
      clearedBalance,
      closingBalancePreviousBusinessDay,
      clearedBalancePreviousBusinessDay,
      isaTaxYearDateDeposits,
      isaTotalDepositAllowance,
    };
  }

  getSideNavMenuAccounts() {
    const sideNavAccounts = {
      iconCss: 'sidebar-icon',
      icon: 'icon-creditCard',
      headerCss: '',
      headerName: 'Your account',
      links: [],
    };
    return sideNavAccounts;
  }
  getSideNavMenuAccountsAlerts() {
    const sideNavAlerts = {
      id: 'alerts',
      linkName: 'Manage alerts',
    };
    return sideNavAlerts;
  }
  getSideNavMenuRenameAccount() {
    const sideNavRenameAccount = {
      id: 'renameAccount',
      linkName: 'Rename account',
    };
    return sideNavRenameAccount;
  }
  getSideNavMenuManageCard() {
    return {
      id: 'manageCard',
      linkName: 'Manage your card',
    };
  }
  getSideNavMenuManageDebitCard() {
    return {
      id: 'manageDebitCards',
      linkName: 'Manage debit cards',
    };
  }
  getSideNavMenuDocumentLib() {
    return {
      id: 'documentLib',
      linkName: StringConstants.DocumentLibQuickLink,
    };
  }
  getSideNavMenuAccountsStatements() {
    const sideNavStmts = {
      id: 'statements',
      linkName: 'View and download statements',
    };
    return sideNavStmts;
  }
  getSideNavMenuPayments() {
    const sideNavPayments = {
      headerCss: '',
      headerName: 'Your scheduled payments',
      iconCss: 'sidebar-icon',
      icon: 'icon-quickLinks',
      links: [],
    };
    return sideNavPayments;
  }
  getManageInsuranceLink(productCode) {
    const sideNavInsurance = {
      id: 'manageInsurance',
      linkName:
        productCode === '755' ? 'Turn off insurance' : 'Turn on insurance',
    };
    return sideNavInsurance;
  }
  getSideNavManageInsurance() {
    const sideNavManageInsurance = {
      headerCss: '',
      headerName: 'Insurance benefits',
      iconCss: 'sidebar-icon',
      icon: 'icon-quickLinks',
      links: [],
    };
    return sideNavManageInsurance;
  }
  getOrders(_params) {
    switch (_params) {
      case 'orderstatement':
        return {
          id: 'orderStatement',
          linkName: ContentStore.get('paperStatement'),
        };
      case 'cheque':
        return {
          id: 'orderCheque',
          linkName: ContentStore.get('chequeBook'),
        };
      case 'payin':
        return {
          id: 'orderPayin',
          linkName: ContentStore.get('payBook'),
        };
      case 'export':
        return {
          id: 'exportTransaction',
          linkName: ContentStore.get('exportTransaction'),
        };
    }
  }
  getSideNavData(accountId) {
    const PAYMENT_LINK_CREDIT_CARD = {
      id: 'payment',
      linkName: 'Manage your scheduled payments',
    };
    const PAYMENT_LINK = {
      id: 'payment',
      linkName:
        'View Direct Debits, standing orders and other scheduled payments',
    };
    const PAYMENT_HISTORY = {
      id: 'paymentStatus',
      linkName: 'Payments status and history',
    };
    const accDetails = AccountsStore.getAccountDetail(accountId);
    const listDataCurrent = [];
    if (
      accDetails.actionsAvailable['/account/mandates/so/read'] ||
      accDetails.actionsAvailable['/account/mandates/dd/read'] ||
      accDetails.actionsAvailable['/account/transactions/read']
    ) {
      const quickLinkSideNavPayments = this.getSideNavMenuPayments();
      if (
        accDetails.actionsAvailable['/account/mandates/so/read'] ||
        accDetails.actionsAvailable['/account/mandates/dd/read']
      ) {
        if (accDetails.type === 'credit_card') {
          quickLinkSideNavPayments.links.push(PAYMENT_LINK_CREDIT_CARD);
        } else {
          quickLinkSideNavPayments.links.push(PAYMENT_LINK);
        }
      }
      if (
        accDetails.actionsAvailable['/account/transactions/read'] ||
        accDetails.actionsAvailable['/account/payments/read']
      ) {
        quickLinkSideNavPayments.links.push(PAYMENT_HISTORY);
      }
      quickLinkSideNavPayments.links.length > 0 &&
        listDataCurrent.push(quickLinkSideNavPayments);
    }
    const listDataSideNavAccount = this.getSideNavMenuAccounts();
    const isAlertsAvailable =
      accDetails.actionsAvailable['/account/alerts'] ||
      accDetails.actionsAvailable['/account/alerts/transaction/debit'] ||
      accDetails.actionsAvailable['/account/alerts/transaction/credit'];

    if (accDetails.actionsAvailable['/users/debit_card/manage']) {
      listDataSideNavAccount.links.push(this.getSideNavMenuManageDebitCard());
    }
    if (isAlertsAvailable) {
      listDataSideNavAccount.links.push(this.getSideNavMenuAccountsAlerts());
    }
    if (isCardManagementEnabledForAccount(accDetails)) {
      listDataSideNavAccount.links.push(this.getSideNavMenuManageCard());
    }
    if (accDetails.actionsAvailable['/account/statements/read']) {
      listDataSideNavAccount.links.push(
        this.getSideNavMenuAccountsStatements()
      );
    }
    if (shouldShowDocumentLib()) {
      listDataSideNavAccount.links.push(this.getSideNavMenuDocumentLib());
    }
    if (
      envConfig.isTransactionExportEnabled &&
      BrowserUtils.getView() === 'desktop' &&
      !BrowserUtils.isTabletLanscapeView() &&
      accDetails.actionsAvailable['/account/transactions/read']
    ) {
      listDataSideNavAccount.links.push(this.getOrders('export'));
    }
    if (
      envConfig.isNicknameAmendEnabled &&
      !UserManagementStore.isNominatedUser()
    ) {
      listDataSideNavAccount.links.push(this.getSideNavMenuRenameAccount());
    }
    if (accDetails.actionsAvailable['/account/statements/order']) {
      listDataSideNavAccount.links.push(this.getOrders('orderstatement'));
    }
    if (accDetails.actionsAvailable['/account/books/cheque/reorder']) {
      listDataSideNavAccount.links.push(this.getOrders('cheque'));
    }
    if (accDetails.actionsAvailable['/account/books/payin/reorder']) {
      listDataSideNavAccount.links.push(this.getOrders('payin'));
    }
    listDataSideNavAccount.links.length > 0 &&
      listDataCurrent.push(listDataSideNavAccount);
    const quickLinkSideNavManageInsurance = this.getSideNavManageInsurance();
    if (
      accDetails?.product?.code === '755' ||
      accDetails?.product?.code === '775'
    ) {
      quickLinkSideNavManageInsurance.links.push(
        this.getManageInsuranceLink(accDetails.product.code)
      );
    }
    quickLinkSideNavManageInsurance.links.length > 0 &&
      listDataCurrent.push(quickLinkSideNavManageInsurance);
    if (accDetails?.product?.code === '472') {
      listDataCurrent.push({
        headerCss: '',
        headerName: 'Private banking monthly fee',
        iconCss: 'sidebar-icon',
        icon: 'icon-quickLinks',
        links: [
          {
            id: 'privateBankingBenefits',
            linkName: 'View all benefits',
          },
        ],
      });
    }
    if (accDetails?.product?.code === '470') {
      listDataCurrent.push({
        headerCss: '',
        headerName: 'Current account tracker monthly fee',
        iconCss: 'sidebar-icon',
        icon: 'icon-quickLinks',
        links: [
          {
            id: 'currentAccountTracker',
            linkName: 'View all benefits',
          },
        ],
      });
    }
    if (
      accDetails?.product?.code === '750' ||
      accDetails?.product?.code === '753' ||
      accDetails?.product?.code === '136'
    ) {
      listDataCurrent.push({
        headerCss: '',
        headerName: 'Looking to upgrade or change your account?',
        iconCss: 'sidebar-icon',
        icon: 'icon-quickLinks',
        links: [
          {
            id: 'upgradeAccount',
            linkName: '',
          },
        ],
      });
    }
    return listDataCurrent;
  }

  getTransactionCategoryTabList(isAccountPool) {
    const transactionTab = [
      {
        id: transactionCategories.DEFAULT,
        title: 'Standard',
        icon: 'ListOutlineSmall',
      },
    ];

    const accountPoolPerAccountTab = {
      id: transactionCategories.PERACCOUNT,
      title: 'Account View',
      icon: 'ListOutlineSmall',
    };
    const transactionTabs = isAccountPool
      ? transactionTab.concat(accountPoolPerAccountTab)
      : transactionTab;

    return transactionTabs;
  }
}

export default new AccountDetailsBL();
